import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import { Button, Modal, Spin, message } from "antd";
import { LoadingOutlined, MoreOutlined } from "@ant-design/icons";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import liracrypt from "../../../Liracrypt/liracrypt";
import ZenModal from "../../../ZenModal";
import { useSelector } from "react-redux";
import ApiErrorComp from "../../../ApiErrorComp/ApiErrorComp";
import { createRoute } from "../../../../utils/CustomFunc";
import noImg from '../../../../assets/static/noImg.jpeg';
import { useLocation } from "react-router-dom";
import queryString from "query-string";
am4core.useTheme(am4themes_animated);
// Notes : The change in Pareto is that there is an extra paretoValueAxis. Max value of value axes has to be sent by backend

const ZenPareto = (props) => {
  const { search } = useLocation();
  const searchParams = queryString.parse(search);
  const urlCode = useSelector(state => state.urlCode);
  const [zenModal, setZenModal] = useState();
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const chart = useRef(null);
  const [chartData, setChartData] = useState();
  const [chartConfig, setChartConfig] = useState();

  const [modal, setModal] = useState({
    type: "route",
    data: undefined,
    show: false,
    loading: false,
  });

  const toggleModal = ({
    show = false,
    data = undefined,
    type = '',
    loading = false,
  }) => {
    setModal({ show, data, type, loading });
  };
  /* CHART CREATION */

  const createChart = (args, chart) => {
    if (args.data) {
      chart.data = args.data;
      if (args.config.legend.enable === true) {
        chart.legend = new am4charts.Legend();
        chart.legend.position = args.config.legend.position;
        chart.legend.labels.template.fill = am4core.color(
          args.config.legend.color
        );
        chart.legend.labels.template.fontSize = args.config.legend.fontSize;
        chart.legend.markers.template.width = args.config.legend.markerWidth;
        chart.legend.markers.template.height = args.config.legend.markerHeight;
        // chart.legend.markers.template.setAll({
        //   width: args.config.legend.markerWidth,
        //   height:args.config.legend.markerHeight,
        // });
      }
      chart.padding(
        args.config.chartDiv.padding[0],
        args.config.chartDiv.padding[1],
        args.config.chartDiv.padding[2],
        args.config.chartDiv.padding[3]
      );
      chart.margin(
        args.config.chartDiv.margin[0],
        args.config.chartDiv.margin[1],
        args.config.chartDiv.margin[2],
        args.config.chartDiv.margin[3]
      );

      /* TITLE */
      if (args.config.title.enable === true) {
        var title = chart.titles.create();
        title.text = args.config.title.val;
        title.fontSize = args.config.title.fontSize;
        title.margin(
          args.config.title.margin[0],
          args.config.title.margin[1],
          args.config.title.margin[2],
          args.config.title.margin[3]
        );
        title.padding(
          args.config.title.padding[0],
          args.config.title.padding[1],
          args.config.title.padding[2],
          args.config.title.padding[3]
        );
        title.fontWeight = args.config.title.fontWeight;
        title.fill = args.config.title.color;
      }

      /* VALUE AXIS */
      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.min = args.config.valueAxis.minVal || 0;
      valueAxis.max = args.config.valueAxis.maxVal;
      valueAxis.renderer.line.strokeOpacity =
        args.config.valueAxis.line.strokeOpacity;
      valueAxis.renderer.line.strokeWidth =
        args.config.valueAxis.line.strokeWidth;
      valueAxis.renderer.line.stroke = am4core.color(
        args.config.valueAxis.line.stroke
      );

      if (args.config.valueAxis.enable === false) {
        valueAxis.renderer.labels.template.disabled = true;
      } else {
        valueAxis.renderer.labels.template.fill =
          args.config.valueAxis.label.fill;
        valueAxis.renderer.labels.template.fontSize =
          args.config.valueAxis.label.fontSize;

      }

      valueAxis.renderer.grid.template.strokeOpacity =
        args.config.valueAxis.grid.strokeOpacity;
      valueAxis.renderer.grid.template.stroke = am4core.color(
        args.config.valueAxis.grid.stroke
      );
      valueAxis.renderer.grid.template.strokeWidth =
        args.config.valueAxis.grid.strokeWidth;

      /*PARETO AXIS */
      var paretoAxis = chart.yAxes.push(new am4charts.ValueAxis());
      paretoAxis.min =  args.config.paretoAxis.minVal || 0;
      paretoAxis.max =  args.config.paretoAxis.maxVal;

      paretoAxis.renderer.opposite = true;
      paretoAxis.renderer.line.strokeOpacity =
        args.config.paretoAxis.line.strokeOpacity;
      paretoAxis.renderer.line.strokeWidth =
        args.config.paretoAxis.line.strokeWidth;
      paretoAxis.renderer.line.stroke = am4core.color(
        args.config.paretoAxis.line.stroke
      );
      if (args.config.paretoAxis.enable === false) {
        paretoAxis.renderer.labels.template.disabled = true;
      } else {
        paretoAxis.renderer.labels.template.fill =
          args.config.paretoAxis.label.fill;
        paretoAxis.renderer.labels.template.fontSize =
          args.config.paretoAxis.label.fontSize;

      }

      paretoAxis.renderer.grid.template.strokeOpacity =
        args.config.paretoAxis.grid.strokeOpacity;
      paretoAxis.renderer.grid.template.stroke = am4core.color(
        args.config.paretoAxis.grid.stroke
      );
      paretoAxis.renderer.grid.template.strokeWidth =
        args.config.paretoAxis.grid.strokeWidth;

      /* CATEGORY AXIS*/
      var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = args.config.categoryAxis.categoryX;
      categoryAxis.renderer.line.strokeOpacity =
        args.config.categoryAxis.line.strokeOpacity;
      categoryAxis.renderer.line.strokeWidth =
        args.config.categoryAxis.line.strokeWidth;
      categoryAxis.renderer.line.stroke = am4core.color(
        args.config.categoryAxis.line.stroke
      );
      categoryAxis.renderer.labels.template.fontSize =
        args.config.categoryAxis.label.fontSize;
      categoryAxis.renderer.labels.template.fill =
        args.config.categoryAxis.label.color;
      categoryAxis.renderer.grid.template.strokeOpacity =
        args.config.categoryAxis.grid.strokeOpacity;
      categoryAxis.renderer.grid.template.stroke = am4core.color(
        args.config.categoryAxis.grid.stroke
      );
      categoryAxis.renderer.grid.template.strokeWidth =
        args.config.categoryAxis.grid.strokeWidth;
      categoryAxis.renderer.minGridDistance =
        args.config.categoryAxis.grid.minGridDistance;
      categoryAxis.renderer.labels.template.dx =
        args.config.categoryAxis.label.dx;
      categoryAxis.renderer.labels.template.dy =
        args.config.categoryAxis.label.dy;
      if (args.config.categoryAxis.label.wrap === true) {
        categoryAxis.renderer.labels.template.wrap = true;
        categoryAxis.renderer.labels.template.maxWidth =
          args.config.categoryAxis.label.maxWidth;
      }
      if (args.config.categoryAxis.label.truncate === true) {
        categoryAxis.renderer.labels.template.truncate = true;
        categoryAxis.renderer.labels.template.maxWidth =
          args.config.categoryAxis.label.maxWidth;
      }

      categoryAxis.events.on("sizechanged", function (ev) {
        var axis = ev.target;
        if (args.config.categoryAxis.label.orientation === "ang") {
          axis.renderer.labels.template.rotation = -45;
          axis.renderer.labels.template.horizontalCenter = "right";
          axis.renderer.labels.template.verticalCenter = "middle";
        } else if (args.config.categoryAxis.label.orientation === "hor") {
          axis.renderer.labels.template.rotation = 0;
          axis.renderer.labels.template.horizontalCenter = "middle";
          axis.renderer.labels.template.verticalCenter = "top";
        } else if (args.config.categoryAxis.label.orientation === "ver") {
          axis.renderer.labels.template.rotation = -90;
          axis.renderer.labels.template.horizontalCenter = "middle";
          axis.renderer.labels.template.verticalCenter = "top";
        }
      });

      /* COLUMN SERIES */
      if (args?.config?.columnSeries?.enable === true) {
        let columnSeries = chart.series.push(new am4charts.ColumnSeries());
        columnSeries.yAxis = valueAxis;
        columnSeries.dataFields.valueY = args.config.columnSeries.valueY;
        columnSeries.dataFields.categoryX = args.config.categoryAxis.categoryX;
        columnSeries.dataFields._id = "_id";
        columnSeries.name = args.config.columnSeries.name;
        columnSeries.columns.template.width = am4core.percent(
          args.config.columnSeries.columnWidth
        );
        columnSeries.columns.template.clickable = true;
        columnSeries.columns.template.tooltipText =
          args.config.columnSeries.tooltipText;
        var columnColor = args.config.columnSeries.fill;
        if (typeof columnColor === "string") {
          columnSeries.columns.template.fill = columnColor;
        } else {
          chart.colors.list = [];
          for (var i = 0; i < columnColor.length; i++) {
            chart.colors.list.push(am4core.color(columnColor[i]));
          }
          columnSeries.columns.template.adapter.add("fill", (fill, target) => {
            return target.dataItem
              ? chart.colors.getIndex(target.dataItem.index)
              : fill;
          });
        }
        columnSeries.columns.template.fillOpacity =
          args.config.columnSeries.fillOpacity;
        columnSeries.columns.template.stroke = args.config.columnSeries.stroke;
        columnSeries.columns.template.strokeOpacity =
          args.config.columnSeries.strokeOpacity;
        columnSeries.columns.template.column.cornerRadius =
          args.config.columnSeries.cornerRadius;
        columnSeries.columns.template.events.on(
          "hit",
          function (ev) {
            if (args?.config?.zenPop?.typ === "comboRefresh") {
              if (props.onChange) {
                let urlData = args?.config?.zenPop?.params;
                let changeKey = args?.config?.zenPop?.comboRefreshId;
                urlData[changeKey] = ev.target.dataItem._id;
                props.onChange({
                  apiUrl: args?.config?.zenPop?.api,
                  urlData,
                  changeKey,
                });
              }
            } else {
              onColumnClick(ev.target.dataItem.dataContext);
            }
          },
          this
        );
        if (args.config.columnSeries.shadow.enable === true) {
          var shadow = columnSeries.filters.push(
            new am4core.DropShadowFilter()
          );
          shadow.dx = args.config.columnSeries.shadow.dx;
          shadow.dy = args.config.columnSeries.shadow.dy;
          shadow.blur = args.config.columnSeries.shadow.blur;
          chart.current = chart;
        }

        if (args.config.columnSeries.label.enable === true) {
          var colSeriesLabel = columnSeries.bullets.push(
            new am4charts.LabelBullet()
          );
          colSeriesLabel.label.fill = am4core.color(
            args.config.columnSeries.label.fill
          );
          colSeriesLabel.label.text = args.config.columnSeries.label.val;
          colSeriesLabel.label.fontSize =
            args.config.columnSeries.label.fontSize;
          colSeriesLabel.label.dx = args.config.columnSeries.label.dx;
          colSeriesLabel.label.dy = args.config.columnSeries.label.dy;
          if (args.config.columnSeries.label.orientation === "ang") {
            colSeriesLabel.label.rotation = -45;
            colSeriesLabel.label.horizontalCenter = "right";
            colSeriesLabel.label.verticalCenter = "middle";
          } else if (args.config.columnSeries.label.orientation === "hor") {
            colSeriesLabel.label.rotation = 0;
            colSeriesLabel.label.verticalCenter =
              args.config.columnSeries.label.verticalCenter;
            colSeriesLabel.label.horizontalCenter =
              args.config.columnSeries.label.horizontalCenter;
          } else if (args.config.columnSeries.label.orientation === "ver") {
            colSeriesLabel.label.rotation = -90;
            colSeriesLabel.label.horizontalCenter = "middle";
            colSeriesLabel.label.verticalCenter = "top";
          }
        }
      }

      // LINE SERIES 1 //
      if (args.config.lineSeries1.enable === true) {
        let lineSeries1 = chart.series.push(new am4charts.LineSeries());
        lineSeries1.name = args.config.lineSeries1.name;
        lineSeries1.yAxis = paretoAxis;
        lineSeries1.dataFields.valueY = args.config.lineSeries1.valueY;
        lineSeries1.dataFields.categoryX = args.config.categoryAxis.categoryX;
        lineSeries1.stroke = am4core.color(args.config.lineSeries1.stroke);
        lineSeries1.strokeWidth = args.config.lineSeries1.strokeWidth;

        if (args.config.lineSeries1.label.enable === true) {
          var lineSeries1Label = lineSeries1.bullets.push(
            new am4charts.LabelBullet()
          );
          lineSeries1Label.label.fill = args.config.lineSeries1.label.fill;
          lineSeries1Label.label.text = args.config.lineSeries1.label.val;
          lineSeries1Label.label.fontSize =
            args.config.lineSeries1.label.fontSize;
          lineSeries1Label.label.dx = args.config.lineSeries1.label.dx;
          lineSeries1Label.label.dy = args.config.lineSeries1.label.dy;
          if (args.config.lineSeries1.label.orientation === "ang") {
            lineSeries1Label.label.rotation = -45;
            lineSeries1Label.label.horizontalCenter = "right";
            lineSeries1Label.label.verticalCenter = "middle";
          } else if (args.config.lineSeries1.label.orientation === "hor") {
            lineSeries1Label.label.rotation = 0;
            lineSeries1Label.label.verticalCenter =
              args.config.lineSeries1.label.verticalCenter;
            lineSeries1Label.label.horizontalCenter =
              args.config.lineSeries1.label.horizontalCenter;
          } else if (args.config.lineSeries1.label.orientation === "ver") {
            lineSeries1Label.label.rotation = -90;
            lineSeries1Label.label.horizontalCenter = "middle";
            lineSeries1Label.label.verticalCenter = "top";
          }
        }

        if (args.config.lineSeries1.circleBullet.enable === true) {
          let circleBullet = lineSeries1.bullets.push(
            new am4charts.CircleBullet()
          );
          circleBullet.circle.radius =
            args.config.lineSeries1.circleBullet.radius;
          circleBullet.circle.fill = am4core.color(
            args.config.lineSeries1.circleBullet.fill
          );
          circleBullet.circle.fillOpacity =
            args.config.lineSeries1.circleBullet.fillOpacity;
          circleBullet.circle.stroke = am4core.color(
            args.config.lineSeries1.circleBullet.stroke
          );
          circleBullet.circle.strokeOpacity =
            args.config.lineSeries1.circleBullet.strokeOpacity;
        }
        if (args.config.lineSeries1.smoothenCurve === true) {
          lineSeries1.tensionX = 0.8;
          lineSeries1.tensionY = 0.8;
        }
        chart.current = chart;
        if (args.config.lineSeries1.shadow.enable === true) {
          var shadow = lineSeries1.filters.push(new am4core.DropShadowFilter());
          shadow.dx = args.config.lineSeries1.shadow.dx;
          shadow.dy = args.config.lineSeries1.shadow.dy;
          shadow.blur = args.config.lineSeries1.shadow.blur;
          chart.current = chart;
        }
      }

      // LINE SERIES 2 //
      if (args.config.lineSeries2.enable === true) {
        let lineSeries2 = chart.series.push(new am4charts.LineSeries());
        lineSeries2.name = args.config.lineSeries2.name;
        lineSeries2.dataFields.valueY = args.config.lineSeries2.valueY;
        lineSeries2.dataFields.categoryX = args.config.categoryAxis.categoryX;
        lineSeries2.stroke = am4core.color(args.config.lineSeries2.stroke);
        lineSeries2.strokeWidth = args.config.lineSeries2.strokeWidth;

        if (args.config.lineSeries2.label.enable === true) {
          var lineSeries2Label = lineSeries2.bullets.push(
            new am4charts.LabelBullet()
          );
          lineSeries2Label.label.fill = args.config.lineSeries2.label.fill;
          lineSeries2Label.label.text = args.config.lineSeries2.label.val;
          lineSeries2Label.label.fontSize =
            args.config.lineSeries2.label.fontSize;
          lineSeries2Label.label.dx = args.config.lineSeries2.label.dx;
          lineSeries2Label.label.dy = args.config.lineSeries2.label.dy;
          if (args.config.lineSeries2.label.orientation === "ang") {
            lineSeries2Label.label.rotation = -45;
            lineSeries2Label.label.horizontalCenter = "right";
            lineSeries2Label.label.verticalCenter = "middle";
          } else if (args.config.lineSeries2.label.orientation === "hor") {
            lineSeries2Label.label.rotation = 0;
            lineSeries2Label.label.verticalCenter =
              args.config.lineSeries2.label.verticalCenter;
            lineSeries2Label.label.horizontalCenter =
              args.config.lineSeries2.label.horizontalCenter;
          } else if (args.config.lineSeries2.label.orientation === "ver") {
            lineSeries2Label.label.rotation = -90;
            lineSeries2Label.label.horizontalCenter = "middle";
            lineSeries2Label.label.verticalCenter = "top";
          }
        }

        if (args.config.lineSeries2.circleBullet.enable === true) {
          let circleBullet = lineSeries2.bullets.push(
            new am4charts.CircleBullet()
          );
          circleBullet.circle.radius =
            args.config.lineSeries2.circleBullet.radius;
          circleBullet.circle.fill = am4core.color(
            args.config.lineSeries2.circleBullet.fill
          );
          circleBullet.circle.fillOpacity =
            args.config.lineSeries2.circleBullet.fillOpacity;
          circleBullet.circle.stroke = am4core.color(
            args.config.lineSeries2.circleBullet.stroke
          );
          circleBullet.circle.strokeOpacity =
            args.config.lineSeries2.circleBullet.strokeOpacity;
        }
        if (args.config.lineSeries2.smoothenCurve === true) {
          lineSeries2.tensionX = 0.8;
          lineSeries2.tensionY = 0.8;
        }
        chart.current = chart;
        if (args.config.lineSeries2.shadow.enable === true) {
          var shadow = lineSeries2.filters.push(new am4core.DropShadowFilter());
          shadow.dx = args.config.lineSeries2.shadow.dx;
          shadow.dy = args.config.lineSeries2.shadow.dy;
          shadow.blur = args.config.lineSeries2.shadow.blur;
          chart.current = chart;
        }
      }

      // WATERMARK//

      if (args.config.watermark.enable === true) {
        var watermark = new am4core.Image();
        watermark.href = args.config.watermark.href;
        chart.plotContainer.children.push(watermark);
        watermark.align = args.config.watermark.align;
        watermark.valign = args.config.watermark.valign;
        watermark.opacity = args.config.watermark.opacity;
        watermark.marginRight = args.config.watermark.marginRight;
        watermark.marginBottom = args.config.watermark.marginBottom;
      }

      chart.cursor = new am4charts.XYCursor();
      chart.cursor.behavior = "panX";
      chart.cursor.lineX.stroke = am4core.color("#f39c12");
      chart.cursor.lineY.stroke = am4core.color("#f39c12");
    }
  };

  const getApiChartData = (args) => {
    let params = { ...args?.params };
    liracrypt
      .get(props.api, { ...props.urlData, ...params })
      .then((response) => {
        console.log(response.data.data[props.divId]);
        if (!response.data.data[props.divId]) {
          return console.log("No Data Found");
        };
        if (props.setChartId) {
          props.setChartId(response.data.data[props.divId].meta._id);
        }
        if (props.setChartDataSource) {
          props.setChartDataSource(response.data.data[props.divId].meta.autoMan);
        }
        setChartData(response.data.data[props.divId]);
        // setTimeout(() => {
        //   chart = am4core.create(props.divId, am4charts.XYChart)
        //   createChart({
        //     data: response.data.data[props.divId].data,
        //     config: response.data.data[props.divId].config
        //   },
        //     chart);
        // }, 500);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (props.refreshChart) {
      getApiChartData();
    }
  }, [props.refreshChart])

  /* CHART CREATION */
  useEffect(() => {
    let chart = null;
    if (props.api) {
      setChartData(null);
      getApiChartData();
    } else if (props.data) {
      setChartData({ data: props.data, config: props.config });
      // setTimeout(() => {
      //   chart = am4core.create(props.divId, am4charts.XYChart)
      //   createChart({ data: props.data, config: props.config }, chart);
      // }, 500);
    }
  }, [props?.data]);

  useEffect(() => {
    var chart = null;
    if (chartData) {
      chart = am4core.create(props.divId, am4charts.XYChart);
      createChart({ data: chartData.data, config: chartData.config }, chart);
      return () => {
        chart.dispose();
      };
    }
  }, [chartData]);

  useEffect(() => {
    let interval;
    if (chartData?.config?.dataRefreshInterval) {
      interval = setInterval(() => {
        getApiChartData();
      }, chartData?.config?.dataRefreshInterval);
    };
    return () => clearInterval(interval);
  }, [chartData?.config?.dataRefreshInterval]);

  const zenPopupAction = (zenPopup, value, record) => {
    let urlData = { ...searchParams, ...props.urlData, ...zenPopup.params };
    if (zenPopup?.props) {
      urlData[zenPopup?.props] = value;
    }
    if (zenPopup?.multiProps) {
      zenPopup?.multiProps.forEach((prop) => {
        urlData[prop] = record[prop];
      });
    }
    if (zenPopup?.typ === 'smodal') {
      toggleModal({
        loading: false,
        show: true,
        data: {
          id: value,
          urlData
        },
        type: zenPopup?.typ
      });
      return;
    };
    if (zenPopup?.typ === 'route') {
      toggleModal({
        loading: false,
        show: true,
        data: {
          route: zenPopup?.route,
          urlData
        },
        type: zenPopup?.typ
      });
      return;
    }
    if (zenPopup?.api) {
      toggleModal({ show: true, loading: true, type: zenPopup?.typ });
      liracrypt.get(`${zenPopup?.api}`, urlData).then(response => {
        toggleModal({
          show: true,
          data: (zenPopup?.typ === 'image' && response?.data?.isSuccess === false) ? noImg : response?.data?.data,
          loading: false,
          type: zenPopup?.typ
        })
      });
      return;
    }
    return toggleModal({
      show: true,
      data: zenPopup?.data,
      loading: false,
      type: zenPopup?.typ
    })
  }

  const onConfirmation = ({ popData, urlData = {}, resolve, reject }) => {
    if (popData.method === 'GET') {
      liracrypt.get(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
    if (popData.method === 'POST') {
      liracrypt.post(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          console.log(err);
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
    if (popData.method === 'PATCH') {
      liracrypt.patch(popData?.api, urlData)
        .then(response => {
          message.success(response.data.message || 'Successfull');
          resolve();
        }).catch(err => {
          ApiErrorComp('Oops Something went wrong');
          reject();
        })
    }
  }

  const onColumnClick = (record) => {
    if (chartData?.config?.zenPop) {
      let zenPopDataIndex = { ...chartData?.config?.zenPop };
      setZenModal(zenPopDataIndex);
      if (zenPopDataIndex?.typ === 'newTab') {
        let zenParams = { ...searchParams, ...props.urlData, ...zenPopDataIndex.params };
        if (zenPopDataIndex?.api) {
          zenParams.api = zenPopDataIndex?.api;
        }
        let route = createRoute({
          props: zenPopDataIndex?.props,
          record,
          multiProps: zenPopDataIndex?.multiProps,
          params: { ...searchParams, ...props.urlData, ...zenParams },
          urlCode,
          route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
        });
        window.open(route, '_blank')
        return;
      };

      if (zenPopDataIndex?.typ === 'confirmationPopUp') {
        let urlData = { ...searchParams, ...props.urlData, ...zenPopDataIndex?.onOk?.params };
        if (zenPopDataIndex?.onOk?.multiProps) {
          zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
            urlData[prop] = record[prop];
          });
        };
        if (zenPopDataIndex?.onOk?.props) {
          urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
        }

        Modal.confirm({
          title: zenPopDataIndex?.text,
          okText: zenPopDataIndex?.okButtonText,
          cancelText: zenPopDataIndex?.cancelButtonText,
          onOk: () => {
            return new Promise((resolve, reject) => {
              onConfirmation({
                popData: zenPopDataIndex?.onOk,
                resolve,
                reject,
                urlData
              });
            }).catch(() => console.log('Oops errors!'));
          }
        });
        return;
      }
      zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

    }
  }

  const onMenuClick = (record = {}) => {
    if (chartData?.config?.menuZenPop) {
      let zenPopDataIndex = { ...chartData?.config?.menuZenPop };
      setZenModal(zenPopDataIndex);
      if (zenPopDataIndex?.typ === 'newTab') {
        let zenParams = { ...searchParams, ...props.urlData, ...zenPopDataIndex.params };
        if (zenPopDataIndex?.api) {
          zenParams.api = zenPopDataIndex?.api;
        }
        let route = createRoute({
          props: zenPopDataIndex?.props,
          record,
          multiProps: zenPopDataIndex?.multiProps,
          params: { ...searchParams, ...props.urlData, ...zenParams },
          urlCode,
          route: zenPopDataIndex?.urlType === 'dynamic' ? record[zenPopDataIndex?.urlKey] : zenPopDataIndex?.route
        });
        window.open(route, '_blank')
        return;
      };

      if (zenPopDataIndex?.typ === 'confirmationPopUp') {
        let urlData = { ...searchParams, ...props.urlData, ...zenPopDataIndex?.onOk?.params };
        if (zenPopDataIndex?.onOk?.multiProps) {
          zenPopDataIndex?.onOk?.multiProps.forEach((prop) => {
            urlData[prop] = record[prop];
          });
        };
        if (zenPopDataIndex?.onOk?.props) {
          urlData[zenPopDataIndex?.onOk?.props] = record[zenPopDataIndex?.onOk?.props];
        }

        Modal.confirm({
          title: zenPopDataIndex?.text,
          okText: zenPopDataIndex?.okButtonText,
          cancelText: zenPopDataIndex?.cancelButtonText,
          onOk: () => {
            return new Promise((resolve, reject) => {
              onConfirmation({
                popData: zenPopDataIndex?.onOk,
                resolve,
                reject,
                urlData
              });
            }).catch(() => console.log('Oops errors!'));
          }
        });
        return;
      }
      zenPopupAction(zenPopDataIndex, record[zenPopDataIndex?.props], record)

    }
  }

  return (
    <div>
      {chartData?.data ? (
        <>
          {
            chartData?.config?.menuZenPop?.enable ?
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button onClick={() => onMenuClick()} type="link" icon={
                  <MoreOutlined />}>{''}</Button>
              </div> : <></>
          }
          <div id={props.divId} style={chartData.config.chartDiv.style}></div>
          <ZenModal
            modal={modal}
            toggleModal={toggleModal}
            smodalCallback={props.api ? getApiChartData : props.smodalCallback}
            refreshData={props.api ? (params) => getApiChartData({ params }) : (params) => props.refreshData({ ...params })}
            zenModal={zenModal}
          />
        </>
      ) : (
        <div className="Loading">
          <Spin indicator={antIcon} tip="Loading..." />
        </div>
      )}
    </div>
  );
};

export default ZenPareto;
